import { GzPurchasePageWebComponent } from './component/GzPurchasePageWebComponent';

export { GzPurchasePageWebComponent };
